import { useTranslation } from 'react-i18next'

import { useFeedback } from '@/components/feedback/feedback-context'
import { Button } from '@/components/primitives/button'
import { runtimeConfig } from '@/config/runtime-config'

/** 跟随部署的 API base 生成公开入口，不复制固定环境域名或包含任何凭据。 */
function buildWecomEntryUrl(profileId: string) {
  const url = new URL(`${runtimeConfig.apiBaseUrl}/app/auth/wecom/start`, window.location.origin)
  url.searchParams.set('profile_id', profileId)
  url.searchParams.set('return_to', '/apps')
  return url.href
}

export function WecomEntryLink({ profileId }: { profileId: string }) {
  const { t } = useTranslation('adminSettings')
  const { showFeedback } = useFeedback()
  const url = buildWecomEntryUrl(profileId)
  const copy = async () => {
    try {
      await navigator.clipboard.writeText(url)
      showFeedback({ tone: 'success', message: t('wecomIdentityProfiles.entry.copied') })
    } catch {
      showFeedback({ tone: 'error', message: t('wecomIdentityProfiles.entry.copyFailed') })
    }
  }
  return (
    <section className="rounded-lg bg-[var(--color-surface-muted)] p-4">
      <div className="mb-2 flex items-center justify-between gap-3">
        <h3 className="text-sm font-medium">{t('wecomIdentityProfiles.entry.title')}</h3>
        <Button size="sm" variant="soft" onClick={() => void copy()}>
          <svg aria-hidden className="size-4" viewBox="0 0 20 20" fill="none">
            <rect
              x="7"
              y="7"
              width="10"
              height="10"
              rx="2"
              stroke="currentColor"
              strokeWidth="1.5"
            />
            <path
              d="M12 4V3a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h1"
              stroke="currentColor"
              strokeWidth="1.5"
              strokeLinecap="round"
            />
          </svg>
          {t('wecomIdentityProfiles.entry.copy')}
        </Button>
      </div>
      <p className="select-all break-all font-mono text-xs leading-5 text-[var(--color-text)]">
        {url}
      </p>
      <p className="mt-2 text-xs leading-5 text-[var(--color-text-muted)]">
        {t('wecomIdentityProfiles.entry.help')}
      </p>
    </section>
  )
}
